export class Logout {
  public static readonly type = '[Auth] Logout';
}
export class Login {
  public static readonly type = '[Auth] Login';
  constructor(public payload?: { accessToken: string }) {}
}
export class GetAuthorizationToken {
  public static readonly type = '[Auth] Get token';
  constructor(public payload: string) {}
}
export class RemoveAccount {
  public static readonly type = '[Auth] Remove account';
  constructor(public payload: string) {}
}
export class BindAccount {
  public static readonly type = '[Auth] Bind account';
}
export class OpenAuthModal {
  public static readonly type = '[Auth] Open Auth Modal';
}
// export class OpenAuthWindow {
//   public static readonly type = '[Auth] Open Auth Window';
//   constructor(public url: string) {}
// }
